import { createAsyncThunk } from "@reduxjs/toolkit";
import { alertVariants } from "@visiblethread/react-components";
import localhost, { downloadFileFromResponse } from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import {
  addToJobQueue,
  removeFromJobQueue,
  showInlineAlert,
} from "slices/app/appSlice";
import { getErrorMessage } from "utils";

export const fetchDocumentStyleTemplates = createAsyncThunk(
  "addInSettings/fetchTemplates",
  async (_, { dispatch }) => {
    dispatch(addToJobQueue("fetchDocumentStyleTemplates"));
    const url = "/nextgen/document-templates";

    try {
      const rsp = await localhost.get(url);
      return rsp?.data || [];
    } catch (err) {
      dispatch(showErrorModal(err));
      return [];
    } finally {
      dispatch(removeFromJobQueue("fetchDocumentStyleTemplates"));
    }
  }
);

export const downloadStyleTemplate = createAsyncThunk(
  "addInSettings/downloadTemplate",
  async ({ id, fileName }, { dispatch }) => {
    dispatch(addToJobQueue("downloadStyleTemplate"));

    try {
      const { data } = await localhost.get(
        `/nextgen/document-templates/${id}/download`,
        { responseType: "blob" }
      );
      downloadFileFromResponse(data, fileName);
    } catch (err) {
      dispatch(showErrorModal(err, "Unable to download style template"));
    } finally {
      dispatch(removeFromJobQueue("downloadStyleTemplate"));
    }
  }
);

export const removeStyleTemplateById = createAsyncThunk(
  "addInSettings/removeTemplate",
  async (templateId, { dispatch }) => {
    dispatch(addToJobQueue("removeStyleTemplateById"));

    try {
      await localhost.delete(`/nextgen/admin/document-templates/${templateId}`);
      return templateId;
    } catch (err) {
      dispatch(
        showInlineAlert({
          variant: alertVariants.danger,
          text: getErrorMessage(err),
        })
      );
      return null;
    } finally {
      dispatch(removeFromJobQueue("removeStyleTemplateById"));
    }
  }
);
